import { render, staticRenderFns } from "./tz-json-viewer.vue?vue&type=template&id=773710a0"
import script from "./tz-json-viewer.vue?vue&type=script&lang=js"
export * from "./tz-json-viewer.vue?vue&type=script&lang=js"
import style0 from "./tz-json-viewer.vue?vue&type=style&index=0&id=773710a0&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports